import getBreadcrumbsForPage from 'commons/getBreadcrumbsForPage';
import desktopStaticNavItems from 'components/nav/shared/data/desktopStaticNavItems';

// Room departments only; Sale's /shop/ url would otherwise match the Home crumb
const ROOM_NAV_ITEMS = desktopStaticNavItems.filter(
  ({ longLabel }) => !!longLabel
);

const toPath = url => `${url ?? ''}`.toLowerCase().replace(/\/?$/, '/');

let breadcrumbsBySlug = null;

// Category links above the product for a URL slug
export const getCategoryLinksForSlug = slug => {
  if (!slug) {
    return [];
  }

  breadcrumbsBySlug = breadcrumbsBySlug ?? getBreadcrumbsForPage('pdp');

  const label = breadcrumbsBySlug[slug];
  const crumbs = typeof label === 'string' ? breadcrumbsBySlug[label] : null;

  return [
    ...(Array.isArray(crumbs) ? crumbs.map(({ link }) => link) : []),
    `/${slug}/`,
  ];
};

// Menu image for the subcategory (L2), else the department (L1); null drops the image column
const getCategoryNavImage = (links = []) => {
  const paths = links.filter(Boolean).map(toPath);

  if (!paths.length) {
    return null;
  }

  const isInPath = ({ url }) => paths.includes(toPath(url));
  const containsPath = item => isInPath(item) || !!item.items?.some(isInPath);

  const department =
    ROOM_NAV_ITEMS.find(isInPath) ??
    ROOM_NAV_ITEMS.find(({ items }) => items?.some(containsPath));

  if (!department) {
    return null;
  }

  // Living room subcategories open a product grid in the menu, so they have no image
  const subcategory = department.items?.find(containsPath);

  if (subcategory?.image) {
    return { src: subcategory.image, alt: subcategory.label };
  }

  return department.image
    ? { src: department.image, alt: department.longLabel }
    : null;
};

export default getCategoryNavImage;
